export interface UserInfoClaimsFromApi {
  pnkl_client_id: string;
  pnkl_user_type: UserTypes;
}

export interface UserFromApi {
  id: number;
  email: string;
  username: string | null;
  firstName: string;
  lastName: string;
  authType: UserAuthType;
  otpChannel: OtpChannelType | null;
  phone: string | null;
  timezone: string | null;
  tokenReauthInterval: number | null;
  passwordResetRequired: boolean;
  lastLoginAttempt: string | null;
  lastPasswordChange: string | null;
  active: boolean;
  roles: UserRoles[];
  teams: UserTeamRef[];
  clientName: string | null;
  isExternal: boolean;
}

export interface User extends UserFromApi {
  rolesMap: Record<UserRoles, boolean>;
  fullName: string;
}

export enum UserRoles {
  ClientAdmin = 'ClientAdmin',
  InvestorRelations = 'InvestorRelations',
  CustomerSupport = 'CustomerSupport',
  IsDeveloper = 'IsDeveloper',
  TradingAccess = 'TradingAccess',
  ComplianceAccess = 'ComplianceAccess',
}

export const UserRolesLabels: Record<UserRoles, string> = {
  [UserRoles.ClientAdmin]: 'Client Admin',
  [UserRoles.InvestorRelations]: 'Investor Relations',
  [UserRoles.CustomerSupport]: 'Customer Support',
  [UserRoles.IsDeveloper]: 'Developer',
  [UserRoles.TradingAccess]: 'Trading Access',
  [UserRoles.ComplianceAccess]: 'Compliance Access',
};

export interface CurrentUserInfoUser extends User {
  clientId: number;
  userType: UserTypes;
}

export interface CurrentUserInfoParsed {
  user: CurrentUserInfoUser;
}

export const userTimeZones = [
  { timeZone: '(UTC -5) New York' },
  { timeZone: '(UTC -6) Chicago' },
  { timeZone: '(UTC -7) Salt Lake City' },
  { timeZone: '(UTC -8) Los Angeles' },
  { timeZone: '(UTC -9) Anchorage' },
  { timeZone: '(UTC -10) Honolulu' },
  { timeZone: '(UTC 0) Greenwich Mean Time' },
  { timeZone: '(UTC +1) Central European Time' },
  { timeZone: '(UTC +8) China Standard Time' },
];

export enum UserAuthType {
  SINGLE_FACTOR = 'SingleFactor',
  TWO_FACTOR = 'TwoFactor',
  SSO = 'Sso',
}

export const AUTH_TYPES_MAP = {
  SINGLE_FACTOR: UserAuthType.SINGLE_FACTOR,
  TWO_FACTOR: UserAuthType.TWO_FACTOR,
  SSO: UserAuthType.SSO,
};

export enum OtpChannelType {
  EMAIL = 'Email',
  MOBILE = 'Mobile',
  QR = 'Qr',
  Empty = '',
}

export const OTP_TYPES_MAP = {
  EMAIL: OtpChannelType.EMAIL,
  MOBILE: OtpChannelType.MOBILE,
  QR: OtpChannelType.QR,
};

export const userAuthTypes = {
  singleFactor: {
    value: UserAuthType.SINGLE_FACTOR,
    label: 'Single-factor authentification',
  },
  multiFactor: {
    value: UserAuthType.TWO_FACTOR,
    label: 'Two-factor authentification',
  },
  sso: {
    value: UserAuthType.SSO,
    label: 'Office 365 Single Sign On',
  },
};

export const multiFactorTypes = {
  email: {
    value: OtpChannelType.EMAIL,
    label: 'Email',
  },
  mobile: {
    value: OtpChannelType.MOBILE,
    label: 'Mobile',
  },
  qr: {
    value: OtpChannelType.QR,
    label: 'QR code',
  },
};

export const requestAuthenticationHours = [4, 8, 24];

export enum UserTypes {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export enum AllowedUserTypeAuthParam {
  INTERNAL = 'i',
  EXTERNAL = 'e',
}

export interface UserTeamRef {
  id: number;
  name: string;
}
